import React from 'react'
import MenuButton from './menu-button'
import { ThemeContext } from 'styles/theme-provider'

import Menu from './menu'
import { Wrapper, LinkItem, Logo, Phone } from './index.styled'

const Header = ({ className }) => {
  const { setShowSplash } = React.useContext(ThemeContext)

  return (
    <>
      <Wrapper className={className}>
        <LinkItem to={'/contact/'}>contact</LinkItem>
        <Logo to={'/'} onClick={() => setShowSplash(true)} />
        <Phone className={'right'} href={'tel:2127561257'} />
        <LinkItem
          to={'/chelsea-new-york-apartment-availbility/'}
          className={'right availability'}
        >
          availability
        </LinkItem>
        <MenuButton />
      </Wrapper>
      <Menu />
    </>
  )
}

export default Header
